module.exports = __webpack_public_path__ + "img/logo.70b9f7ab.png";